import { deleteMessage, getDraftMessageList, getInboxMessageList, getOutBoxMessageList, getStarredMessageList, starMessage, messageMarkAsReadUnread } from "api/message";
import { OPEN_DRAFT, OPEN_INBOX, OPEN_OUTBOX, OPEN_STARRED } from "config/constants";
import _ from "lodash";
import { DraftMessageMapper, InboxMessageMapper, OutboxMessageMapper } from "mappers/MessageMapper";
import { useReducer, createContext } from "react";
export const initialState = {
    messageList: [],
    menuAction: OPEN_INBOX,
    selectedRecord: null,
    loading: true,
    pageLoading: true,
    error: false,
    totalCount: 0,
    pageNo: 0,
    messageOpened: null,
    selectedIndex: 0,
    replyIndex: 0,
    messageReplyAction: null,
    errorMessage: null,
    outbox: { list: [], totalCount: 0, pageNo: 0 },
    inbox: { list: [], totalCount: 0, pageNo: 0 },
    openedMessageIndex: null,
    searchData: null,
    type: null,/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
    pendingMenu:null,/** Midhila Velayudhan 18/10/2022 */

};
export const messageContext = createContext({
    state: initialState,
    dispatch: () => undefined,
});

export const types = {
    FETCH_MESSAGES_STARTED: "FETCH_MESSAGES_STARTED",
    CATCH_ERROR_DETAILS: "CATCH_ERROR_DETAILS",
    GET_MESSAGES_LIST: "GET_INBOX_MESSAGES",
    // GET_OUTBOX_MESSAGES: "GET_OUTBOX_MESSAGES",
    OPEN_MESSAGE_MENU: "OPEN_MESSAGE_MENU",
    OPEN_MESSAGE_VIEW: "OPEN_MESSAGE_VIEW",
    REPLY_MESSAGE_VIEW: "REPLY_MESSAGE_VIEW",
    DELETE_MESSAGE: "DELETE_MESSAGE",/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
    STAR_MESSAGE: "STAR_MESSAGE",/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
    STAR_MESSAGE_PENDING: "STAR_MESSAGE_PENDING",/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
    FORWARD_MESSAGE_VIEW: "FORWARD_MESSAGE_VIEW",/** Bug #1009  Midhila Velayudhan 04/10/2022*/
    READ_UNREAD_MESSAGE: "READ_UNREAD_MESSAGE" ,/** Date :03/09/2022 Midhila Velayudhan */
    SET_PENDING_MENU: 'SET_PENDING_MENU'
};
export const reducer = (state, action) => {
    switch (action.type) {
        case types.FETCH_MESSAGES_STARTED:
            return { ...state, pageLoading: true, error: false, type: action.type };
        case types.CATCH_ERROR_DETAILS:
            return {
                ...state,
                error: true,
                // outboxList: [],
                // inboxList: [],
                loading: false,
                pageLoading: false,
                errorMessage: "Someting Went Wrong",
                type: action.type
            };
        case types.GET_MESSAGES_LIST: {
            const data = {};
            data[action?.payload?.menuAction] = {
                list: action?.payload?.pageNo == 0 ? [...action?.payload?.list] : [...state[action?.payload?.menuAction].list, ...action?.payload?.list],
                totalCount: action?.payload?.totalCount,
                pageNo: action?.payload?.pageNo,
                unreadCount: action?.payload?.unreadCount
            }
            return {
                ...state,
                ...data,
                loading: false,
                // totalCount: action?.payload?.totalCount,
                error: false,
                type: action.type,
                //pageNo: action?.payload?.pageNo,
                searchData: action?.payload?.searchData,
                pageLoading: false
            }
        };
        // case types.GET_OUTBOX_MESSAGES: {
        //     const data = {};
        //     data[OPEN_INBOX] = {
        //         list: action?.payload?.pageNo == 0 ? [...action?.payload?.list] : [...state.outbox.list, ...action?.payload?.list],
        //         totalCount: action?.payload?.totalCount,
        //         pageNo: action?.payload?.pageNo,
        //     }
        //     return {
        //         ...state,
        //         ...data,
        //         error: false,
        //         loading: false, 
        //         type: action.type,
        //         // pageNo: action?.payload?.pageNo,
        //         searchData:action?.payload?.searchData
        //     }
        // };
        case types.OPEN_MESSAGE_MENU: {
            return {
                ...state,
                menuAction: action?.payload?.menuAction,
                selectedRecord: action?.payload?.selectedRecord,
                messageOpened: null,
                selectedIndex: 0,
                replyIndex: 0,
                messageReplyAction: null,
                loading: true,
                pageLoading: true,
                // outbox: { list: [], totalCount: 0, pageNo: 0 },
                // inbox: { list: [], totalCount: 0, pageNo: 0 },
                openedMessageIndex: null,
                type: action.type
            };
        }
        case types.SET_PENDING_MENU: {
            return {
                ...state,
                pendingMenu: action?.payload?.pendingMenu,
            };
        }
        case types.OPEN_MESSAGE_VIEW: {
            return {
                ...state,
                messageOpened: action?.payload?.messageOpened,
                selectedIndex: action?.payload?.selectedIndex,
                selectedRecord: null,
                replyIndex: 0,
                messageReplyAction: null,
                openedMessageIndex: action?.payload?.openedMessageIndex,
                type: action.type

            };
        }
        case types.FORWARD_MESSAGE_VIEW:
        case types.REPLY_MESSAGE_VIEW: {

            return {
                ...state,
                selectedRecord: action?.payload?.selectedRecord,
                replyIndex: action?.payload?.replyIndex,
                messageReplyAction: action?.payload?.messageReply,
                // outbox: { list: [], totalCount: 0, pageNo: 0 },
                // inbox: { list: [], totalCount: 0, pageNo: 0 }, 
                type: action.type
            };
        }
        case types.DELETE_MESSAGE: {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
            let data = {}
            data[state.menuAction] = state[state.menuAction]
            // if(state.menuAction === OPEN_INBOX) 
            // {  
            data[state.menuAction].list = data[state.menuAction].list?.filter((item) => item?.id != action?.payload.portalMessageId)
            data[state.menuAction].totalCount = data[state.menuAction].totalCount > 0 ? data[state.menuAction].totalCount - 1 : 0;
            // pageNo: state.inbox.pageNo }}

            // }else {
            //   const outBoxList = state.outbox.list?.filter((item)=>item?.id != action?.payload.portalMessageId)
            //     data = {outbox: { list: outBoxList,
            //         totalCount: state.outbox.totalCount > 0 ? state.outbox.totalCount - 1 : 0,
            //         pageNo: state.outbox.pageNo }}
            // }

            return {
                ...state,
                messageOpened: null,
                selectedIndex: 0,
                replyIndex: 0,
                messageReplyAction: null,
                ...data,
                type: action.type
            };
        }
        case types.STAR_MESSAGE: {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
            let data: any = {}
            data[state.menuAction] = state[state.menuAction]
            if (state.menuAction === OPEN_STARRED) {
                data[state.menuAction].list = data[state.menuAction]?.list?.filter((item) => item?.id != action?.payload.portalMessageId);
                data[state.menuAction].totalCount = data[state.menuAction].totalCount > 0 ? data[state.menuAction].totalCount - 1 : 0;
                data = {
                    ...data, messageOpened: null,
                    selectedIndex: 0,
                    replyIndex: 0,
                    messageReplyAction: null
                }
            } else {
                data[state.menuAction].list = data[state.menuAction]?.list?.map((item) => {
                    if (item?.id == action?.payload.portalMessageId) {
                        item.msgStarred = action?.payload?.msgStarred == 1 ? true : false
                        item.list.starMessageLoading = false
                    }
                    return item;
                });
                if (state.messageOpened?.id == action?.payload.portalMessageId) {
                    let messageOpened = state.messageOpened;
                    messageOpened.msgStarred = action?.payload?.starredStatus == 1 ? true : false
                    messageOpened.starMessageLoading = false
                    data.messageOpened = messageOpened
                }
            }

            return {
                ...state,
                ...data,
                type: action.type
            };
        }
        case types.STAR_MESSAGE_PENDING: {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
            let data: any = {}
            data[state.menuAction] = state[state.menuAction]

            data[state.menuAction].list = data[state.menuAction]?.list?.map((item) => {
                if (item?.id == action?.payload.portalMessageId) {
                    item.list.starMessageLoading = true
                }
                return item;
            });
            if (state.messageOpened?.id == action?.payload.portalMessageId) {
                let messageOpened = state?.messageOpened;
                messageOpened.starMessageLoading = true
                data.messageOpened = messageOpened
            }
            return {
                ...state,
                ...data,
                type: action.type
            };
        }
        case types.READ_UNREAD_MESSAGE: {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
            let data: any = {}
            data[state.menuAction] = state[state.menuAction]
            data[state.menuAction].list = data[state.menuAction]?.list?.map((item) => {
                if (item?.id == action?.payload.portalMessageId) {
                    item.msgRead = action?.payload?.readStatus == 1 ? true : false
                }
                return item;
            });
            if(state.menuAction !== OPEN_STARRED){
               state[OPEN_INBOX].unreadCount = action?.payload?.readStatus == 0 ? state[OPEN_INBOX]?.unreadCount + 1 : state[OPEN_INBOX]?.unreadCount - 1; 
            } 
            // let data: any = {}
            // if(state.menuAction === OPEN_INBOX) 
            // {  const inboxList = state.inbox.list?.map((item)=>{
            //     if(item?.id == action?.payload.portalMessageId){
            //         item.msgRead = action?.payload?.readStatus == 1 ? true : false
            //     }
            //     return item;
            // });
            //     data = {inbox: { list: inboxList,
            //         totalCount: state.inbox.totalCount ,
            //         pageNo: state.inbox.pageNo }}

            // }
            // else {
            //   const outBoxList = state.outbox.list?.map((item)=>{
            //     if(item?.id == action?.payload.portalMessageId){
            //         item.msgRead = action?.payload?.readStatus == 1 ? true : false
            //     }
            //     return item;
            // });
            //     data = {outbox: { list: outBoxList,
            //         totalCount: state.outbox.totalCount ,
            //         pageNo: state.outbox.pageNo }}
            // }

            if (state?.messageOpened?.id == action?.payload.portalMessageId) {
                let messageOpened = state.messageOpened;
                messageOpened.msgRead = action?.payload?.readStatus == 1 ? true : false
                data.messageOpened = messageOpened
            }

            return {
                ...state,
                ...data,
                type: action.type
            };
        }
        default: {
            return state;
        }
    }
};
export const actions = {

    openMessageMenu: (dispatch, menuAction, selectedMessage) => {

        dispatch({
            type: types.OPEN_MESSAGE_MENU,
            payload: {
                menuAction: menuAction,
                selectedRecord: selectedMessage,
            },
        });
    },

    setPendingMenu: (dispatch, pendingMenu) => {
        dispatch({
            type: types.SET_PENDING_MENU,
            payload: {
                pendingMenu: pendingMenu,
            },
        });
    },
    
    openMessageView: (dispatch, messageOpened, selectedIndex, index) => {
        dispatch({
            type: types.OPEN_MESSAGE_VIEW,
            payload: {
                messageOpened: messageOpened,
                selectedIndex: selectedIndex,
                openedMessageIndex: index
            },
        });
    },

    openMessageReply: (dispatch, messageReply, replyIndex, selectedRecord) => {
        dispatch({
            type: types.REPLY_MESSAGE_VIEW,
            payload: {
                messageReply: messageReply,
                selectedRecord: selectedRecord,
                replyIndex: replyIndex
            }
        })
    },
    openMessageForward: (dispatch, messageForward, replyIndex, selectedRecord) => {
        dispatch({
            type: types.FORWARD_MESSAGE_VIEW,
            payload: {
                messageReply: messageForward,
                selectedRecord: selectedRecord,
                replyIndex: replyIndex
            }
        })
    },

    showInboxMessageList: (dispatch, pageNo = 0, pageSize = 10, searchData = null) => {
        let data = {}
        searchData && (searchData !== " ") ?
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
                searchParam: searchData
            } :
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
            };
        getInboxMessageList(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.GET_MESSAGES_LIST,
                    payload: {
                        list: _.map(response.data.list, (item, index) => InboxMessageMapper(item, response?.data?.data?.currentDateTime, index)),
                        totalCount: response.data.totalCount,
                        pageLoading: false,
                        loading: true,
                        pageNo: pageNo,
                        searchData: searchData,
                        menuAction: OPEN_INBOX,
                        unreadCount: response?.data?.data?.unreadCount
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    showOutboxMessageList: (dispatch, pageNo = 0, pageSize = 10, searchData = null) => {
        let data = {}
        searchData && (searchData !== " ") ?
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
                searchParam: searchData
            } :
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
            };
        getOutBoxMessageList(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.GET_MESSAGES_LIST,
                    payload: {
                        list: _.map(response.data.list, (item, index) => OutboxMessageMapper(item, response?.data?.data?.currentDateTime, index)),
                        totalCount: response.data.totalCount,
                        pageLoading: false,
                        loading: false,
                        pageNo: pageNo,
                        searchData: searchData,
                        menuAction: OPEN_OUTBOX
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    showDraftMessageList: (dispatch, pageNo = 0, pageSize = 10, searchData = null) => {
        let data = {}
        searchData && (searchData !== " ") ?
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
                searchParam: searchData
            } :
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
            };
        getDraftMessageList(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.GET_MESSAGES_LIST,
                    payload: {
                        list: _.map(response.data.list, (item, index) => DraftMessageMapper(item, response?.data?.data?.currentDateTime, index)),
                        totalCount: response.data.totalCount,
                        pageLoading: false,
                        loading: false,
                        pageNo: pageNo,
                        searchData: searchData,
                        menuAction: OPEN_DRAFT
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    showStarredMessageList: (dispatch, pageNo = 0, pageSize = 10, searchData = null) => {
        let data = {}
        searchData && (searchData !== " ") ?
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
                searchParam: searchData
            } :
            data = {
                pageNo: pageNo,
                pageSize: pageSize,
            };
        getStarredMessageList(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.GET_MESSAGES_LIST,
                    payload: {
                        list: _.map(response.data.list, (item, index) => InboxMessageMapper(item, response?.data?.data?.currentDateTime, index)),
                        totalCount: response.data.totalCount,
                        pageLoading: false,
                        loading: false,
                        pageNo: pageNo,
                        searchData: searchData,
                        menuAction: OPEN_STARRED
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    deleteMessage: (dispatch, portalMessageId) => {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */

        let data = {
            portalMessageId,
        };
        deleteMessage(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.DELETE_MESSAGE,
                    payload: {
                        portalMessageId
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    starMessage: (dispatch, portalMessageId, starredStatus) => {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
        dispatch({
            type: types.STAR_MESSAGE_PENDING,
            payload: {
                portalMessageId,
            },
        })

        let data = {
            portalMessageId,
            starredStatus
        };
        starMessage(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.STAR_MESSAGE,
                    payload: {
                        portalMessageId,
                        starredStatus
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {
            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    },
    messageReadUnread: (dispatch, portalMessageId, readStatus) => {/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */

        let data = {
            portalMessageId,
            readStatus
        };
        messageMarkAsReadUnread(data).then((response) => {
            if (response?.data?.success) {
                dispatch({
                    type: types.READ_UNREAD_MESSAGE,
                    payload: {
                        portalMessageId,
                        readStatus
                    },
                });
            } else {
                dispatch({ type: types.CATCH_ERROR_DETAILS })
            }

        }).catch((e) => {

            dispatch({ type: types.CATCH_ERROR_DETAILS })
        });
    }
};

export const MessageProvider = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <messageContext.Provider
            value={{ ...props, dispatch: dispatch, state: { ...state } }}
        >
            {props.children}
        </messageContext.Provider>
    );
};
